export { default } from "./AppsConfig.vue";
